import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=016b16a1&scoped=true&"
import script from "./Department.vue?vue&type=script&lang=js&"
export * from "./Department.vue?vue&type=script&lang=js&"
import style0 from "./Department.vue?vue&type=style&index=0&id=016b16a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b16a1",
  null
  
)

export default component.exports